export enum EValidityType {
  TODAY = "TODAY",
  UNTIL_CANCEL = "UNTIL_CANCEL",
  UNTIL_DATE = "UNTIL_DATE",
}

export const validityLabels: Record<EValidityType, string> = {
  [EValidityType.TODAY]:
    "global.predictives_buy_card.data_predictive_input.today",
  [EValidityType.UNTIL_CANCEL]:
    "global.predictives_buy_card.data_predictive_input.until_cancel",
  [EValidityType.UNTIL_DATE]:
    "global.predictives_buy_card.data_predictive_input.custom",
};

export const getValidityLabel = (validity: string): string => {
  if (validity === EValidityType.TODAY) {
    return validityLabels[EValidityType.TODAY];
  }
  if (validity === EValidityType.UNTIL_CANCEL) {
    return validityLabels[EValidityType.UNTIL_CANCEL];
  }
  if (validity === EValidityType.UNTIL_DATE) {
    return validityLabels[EValidityType.UNTIL_DATE];
  }
  return validityLabels[EValidityType.TODAY];
};
